import available_flag from "../../../Assets/Flags/available_flag.svg";
import { Container, Flag, Price, State } from "./style";
import { ICardHUProps } from "../../../Interfaces";
import { StateContainer } from "../OccupiedInfo/style";
import { formatter } from "../../../Utils";

interface IAvailableInfosProps {
  isReserved: boolean;
}

const AvailableInfos = ({
  data,
  isReserved,
}: ICardHUProps & IAvailableInfosProps) => {
  const { price, state } = data;

  return (
    <Container>
      <StateContainer>
        <Flag src={available_flag} />
        <State state={state} isReserved={isReserved}>
          livre
        </State>
      </StateContainer>
      <Price>{formatter.format(price)}</Price>
    </Container>
  );
};
export default AvailableInfos;
